import type { AxiosResponse } from 'axios';
import type { SubServiceType } from '@app-types/models/plan';
import api from './api';

interface SubServiceTypesResponse {
  subServiceTypes: SubServiceType[];
  [key: string]: unknown;
}

export const getSubServiceTypes = async (): Promise<SubServiceTypesResponse> => {
  const response: AxiosResponse<SubServiceTypesResponse> = await api.get('/services/subservicetypes');
  return response.data;
};
